import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-harness.svg";
import * as styles from "./Icon.module.scss";

type HarnessRacingProps = React.SVGProps<SVGSVGElement>;

export const HarnessRacing = ({ className, ...props }: HarnessRacingProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
